import localMediaRecordingOld from "../../../lib/localRecording";
import localMediaRecording from "../../../lib/localRecordingNew";

export function getLocalMediaRecordingInstance(localRecordingStreaming: boolean) {
  if (localRecordingStreaming) {
    return localMediaRecording;
  } else {
    return localMediaRecordingOld;
  }
}
